import * as THREE from 'three'
import Camera from './Camera'
import Debug from './utils/Debug'
import Resources from './utils/Resources'
import Sizes from './utils/Sizes'
import Time from './utils/Time'
import sources from './sources'
import Renderer from './Renderer'
import World from './world/World'

let instance = null

export default class Experience {

    constructor(canvas) {

        if (instance) {
            return instance
        }

        instance = this

        window.experience = this

        this.canvas = canvas

        this.debug = new Debug()
        this.sizes = new Sizes()
        this.time = new Time()

        this.scene = new THREE.Scene()

        this.resources = new Resources(sources)

        this.world = new World()
        this.camera = new Camera()
        this.renderer = new Renderer()

        this.sizes.on('resize', () => {
            this.resize()
        })

        this.time.on('tick', () => {
            this.update()
        })

        // console.log(this)
    }

    resize() {
        this.camera.resize()
        this.renderer.resize()
    }

    update() {
        this.camera.update()
        this.world.update()
        this.renderer.update()
    }

    destroy() {

        this.sizes.off('resize')
        this.time.off('tick')

        // scorro la scena per eliminare gli elementi
        this.scene.traverse((child) => {

            if (child instanceof THREE.Mesh) {

                // elimina geometria
                child.geometry.dispose()

                // per ogni geometria cerca tutti i material
                for (const key in child.material) {

                    const value = child.material[key]

                    // se il material ha una funzione dispose, vine lanciata
                    if (value && typeof value.dispose === 'function') {
                        value.dispose()
                    }
                }
            }
        })

        // rimuovo controlli
        this.camera.controls.dispose()

        this.renderer.instance.dispose()

        if (this.debug.active) {

            this.debug.ui.destroy()
        }

        // RIMUOVERE EVENT LISTENERS
        // ...
    }
}